<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card" *ngIf="user['@rid'] != '#-1:-1'">
                <div class="card-header">
                    <strong *ngIf="mode == 'edit'">{{ 'user.edit_member_info' | transloco }}</strong>
                    <strong *ngIf="mode != 'edit'">{{ 'user.member_info' | transloco }}</strong>
                </div>
                <div class="card-body">
                    <form class="form-horizontal" [formGroup]="editForm">
                        <fieldset [disabled]="mode == 'view'">
                            <div class="form-group row">
                                <label class="col-3 col-md-3 form-control-label">{{ 'user.username' | transloco }}</label>
                                <div class="col-9 col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(editForm,username,'username')}" [tooltip]="'user.username_min_length' | transloco" triggers="" #username="bs-tooltip" placement="top">
                                    <input *ngIf="mode == 'edit'" type="text" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(editForm, 'username')}" formControlName="username" [(ngModel)]="user.name" [placeholder]="'user.username' | transloco">
                                    <span *ngIf="mode != 'edit'">{{user.name}}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-3 col-md-3 form-control-label">{{ 'user.member_name' | transloco }}</label>
                                <div class="col-9 col-md-9">
                                    <input *ngIf="mode == 'edit'" type="text" class="form-control" formControlName="memberName" [(ngModel)]="user.memberName" [placeholder]="'user.member_name' | transloco">
                                    <span *ngIf="mode != 'edit'">{{user.memberName}}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-3 col-md-3 form-control-label">{{ 'user.administrator_name' | transloco }}</label>
                                <div class="col-9 col-md-9">
                                    <input *ngIf="mode == 'edit'" type="text" class="form-control" formControlName="administratorName" [(ngModel)]="user.administratorName" [placeholder]="'user.administrator_name' | transloco">
                                    <span *ngIf="mode != 'edit'">{{user.administratorName}}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-3 col-md-3 form-control-label">{{ 'user.telephone' | transloco }}</label>
                                <div class="col-9 col-md-9">
                                    <input *ngIf="mode == 'edit'" type="text" class="form-control" formControlName="telephone" [(ngModel)]="user.telephone" [placeholder]="'user.telephone' | transloco">
                                    <span *ngIf="mode != 'edit'">{{user.telephone}}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-3 col-md-3 form-control-label">{{ 'user.fax' | transloco }}</label>
                                <div class="col-9 col-md-9">
                                    <input *ngIf="mode == 'edit'" type="text" class="form-control" formControlName="fax" [(ngModel)]="user.fax" [placeholder]="'user.fax' | transloco">
                                    <span *ngIf="mode != 'edit'">{{user.fax}}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-3 col-md-3 form-control-label">{{ 'user.address' | transloco }}</label>
                                <div class="col-9 col-md-9">
                                    <input *ngIf="mode == 'edit'" type="text" class="form-control" formControlName="address" [(ngModel)]="user.address" [placeholder]="'user.address' | transloco">
                                    <span *ngIf="mode != 'edit'">{{user.address}}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-3 col-md-3 form-control-label">{{ 'user.buyer' | transloco }}</label>
                                <div class="col-9 col-md-3">
                                    <input type="checkbox" class="form-control" [(ngModel)]="user.buyer" [ngModelOptions]="{standalone: true}" [placeholder]="'user.buyer' | transloco">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-3 col-md-3 form-control-label">{{ 'user.seller' | transloco }}</label>
                                <div class="col-9 col-md-3">
                                    <input type="checkbox" class="form-control" [(ngModel)]="user.seller" [ngModelOptions]="{standalone: true}" [placeholder]="'user.seller' | transloco">
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <strong>{{ 'user.password' | transloco }}</strong>
                </div>
                <div class="card-body">
                    <form class="form-horizontal" [formGroup]="passwordForm">
                        <div formGroupName="password">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">{{ 'user.password' | transloco }}</label>
                                <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(passwordForm,newPassword,'password','newPassword')}" [tooltip]="'user.password_min_length' | transloco" triggers="" #newPassword="bs-tooltip" placement="top">
                                    <input type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(passwordForm, 'password','newPassword')}" formControlName="newPassword" [(ngModel)]="password" [placeholder]="'user.password' | transloco">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">{{ 'user.confirm_password' | transloco }}</label>
                                <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(passwordForm,confirmPassword,'password')}" [tooltip]="'user.password_mismatch' | transloco" triggers="" #confirmPassword="bs-tooltip" placement="top">
                                    <input type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(passwordForm, 'password')}" formControlName="confirmPassword" [placeholder]="'user.confirm_password' | transloco">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-footer">
                    <div class="col-sm-12">
                        <button type="button" [disabled]="!passwordForm.valid" class="btn btn-block btn-primary" (click)="changePassword()"><i class="fa fa-dot-circle-o"></i> {{ 'user.change' | transloco }}</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
